<template>
  <div style="height: 100%">
    <table-list
        ref="list"
        :height="height"
        :request-params="{type: currentFlag}"
        @query="handleSearch"
        :auto="false"
        @selection-change="selection = $event"
        :data="tableData">
      <el-table-column type="selection" width="50" />
      <el-table-column :label="$t('编号')" prop="num" />
      <!--   编号配置  -->
      <template v-if="p1List.length">
        <el-table-column v-for="item in p1List" :key="item.prop" :label="$t(item.label)" :prop="item.prop">
          <template v-slot="{row}">
            <el-link :underline="false" type="primary">{{row[item.prop]}}</el-link>
          </template>
        </el-table-column>
      </template>

      <el-table-column :label="$t('被举报者编号')">
        <template v-slot="{row}">
          <el-link :underline="false" type="primary">{{ row.beReportUserNum }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="beReportUserName" :label="$t('被举报者昵称')" />

      <!--   举报内容配置  -->
      <template v-if="p2List.length">
        <el-table-column v-for="(item, index) in p2List" :key="index" :label="$t(item.label)" :prop="item.prop">
          <template v-slot="{row}">
            <preview-img v-if="item.type === 'img'" :img-url="row[item.prop]" :size="50" :length="1" />
            <span v-else>{{row[item.prop]}}</span>
          </template>
        </el-table-column>
      </template>

      <el-table-column :label="$t('举报类型')">
        <template v-slot="{row}">
          <dict-text dict-flag="REPORT_TYPE"  :status="row.reportType" />
        </template>
      </el-table-column>
      <el-table-column :label="$t('举报原因')" prop="reportReason" />
      <el-table-column :label="$t('举报者编号')">
        <template v-slot="{row}">
          <el-link :underline="false" type="primary">{{ row.reportUserNum }}</el-link>
        </template>
      </el-table-column>
      <el-table-column :label="$t('举报者昵称')" prop="reportUserName" />
      <el-table-column :label="$t('举报时间')">
        <template v-slot="{row}">
          {{row.createTime | formatDate}}
        </template>
      </el-table-column>
      <el-table-column :label="$t('状态')" prop="handleStatus">
        <template v-slot="{row}">
          <dict-text dict-flag="REPORT_STATUS" :status="row.status" />
        </template>
      </el-table-column>

      <el-table-column :label="$t('处理结果')" prop="handleStatus">
        <template v-slot="{row}">
          <dict-text dict-flag="REPORT_PROCESS_STATE" :status="row.handleStatus" />
        </template>
      </el-table-column>

      <el-table-column :label="$t('备注')" prop="remark" />
      <el-table-column :label="$t('操作')">
        <template v-slot="{row}">
          <div class="fb-link-flex">
            <el-link :underline="false" type="primary" @click="$refs.auditForm.handleShowDialog(row)" v-if="row.status === 'ready' || !row.status">{{$t('审核')}}</el-link>
            <el-link :underline="false" type="primary" @click="$refs.disposeForm.handleShowDialog(row)" v-else-if="row.status === 'toHandle'">{{$t('处理')}}</el-link>
            <el-link :underline="false" type="danger" @click="handleDelete(row)">{{$t('删除')}}</el-link>
          </div>
        </template>
      </el-table-column>
    </table-list>

    <report-audit
        ref="auditForm"
        @refresh="$refs.list.handleRequest()" />

    <report-dispose-form
        ref="disposeForm"
        @refresh="$refs.list.handleRequest()" />
  </div>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request, requestByTip} from "@/config/request";
import DictText from "@/components/dict/DictText";
import ReportAudit from "@/components/report/ReportAudit";
import ReportDisposeForm from "@/components/report/ReportDisposeForm";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";
export default {
  name: "ReportTable",
  components: {PreviewImg, ReportDisposeForm, ReportAudit, DictText, TableList},
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    },

    currentFlag: {
      type: String,
      default: "dynamics"
    },
    height: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tableData: [],
      selection: []
    }
  },
  methods: {
    async handleDelete(row) {
      try {
        await requestByTip(this.$api.report.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest(1);
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: this.$t('未选择记录')
        });
        return;
      }
      try {
        let codes = this.selection.map(item => item.code);
        await requestByTip(
            this.$api.report.batchDelete,
            codes,
            {isJson: true},
            {message: this.$t('您现在正在进行批量删除操作, 是否继续?')}
        );
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest(codes.length);
      } catch (e) {
        console.error(e);
      }
    },


    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.report.list, params);
        this.tableData = res.reports;
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    }
  },
  computed: {
    p1List() {
      return this.list.filter(item => item.position === 'p1')
    },
    p2List() {
      return this.list.filter(item => item.position === 'p2')
    }
  },
  watch: {
    currentFlag: {
      handler() {
        this.$nextTick(() => {
          this.tableData = [];
          this.$refs.list.handleSearch();
        })
      },
      immediate: true,
    }
  }
}
</script>

<style scoped>

</style>
